import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect } from 'react'
import { Modal } from 'react-bootstrap'

let modalStack = [];

export default function Popup({ isshow, size, title, closePopup, modalBody, handleSave, visibleSaveBtn,
    btnText, ExtraText, handleSaveForExtra, extraBtn, btntype, modalfooter, hideCloseButton, isBlur, isCentered = false, isScrollable = false }) {
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key == 'Escape') {
                const topModal = modalStack[modalStack.length - 1];
                if (topModal == closePopup) {
                    closePopup();
                }
            }
        };

        if (isshow) {
            window.addEventListener('keydown', handleKeyDown);
        }

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [isshow, closePopup]);

    useEffect(() => {
        if (isshow) { modalStack.push(closePopup) }
        return () => { modalStack = modalStack.filter(fn => fn !== closePopup) };
    }, [isshow, closePopup]);

    return (
        <Modal show={isshow} size={size} style={{
            filter: isBlur ? "brightness(0.5)" : "brightness(1)"
        }} centered={isCentered} scrollable={isScrollable}>
            < Modal.Header className='d-flex justify-content-between' >
                <Modal.Title>
                    <b className='font-16'>{title}</b>
                </Modal.Title>
                {!hideCloseButton && <FontAwesomeIcon icon={faTimes} className='cursor-pointer' onClick={closePopup} />}
            </ Modal.Header>
            <Modal.Body>
                {modalBody}
            </Modal.Body>
            <Modal.Footer>
                {modalfooter ?
                    modalfooter
                    :
                    <>
                        {!hideCloseButton &&
                            <label className="ms-2 cursor-pointer" onClick={closePopup}><u>Cancel</u></label>
                        }
                        {extraBtn && (
                            <button className={`${btntype ? 'SaveBtn' : 'Cancel-btn'} px-3`} onClick={handleSaveForExtra}>{ExtraText}</button>
                        )}
                        {visibleSaveBtn && (
                            <button className='SaveBtn' onClick={handleSave}>{btnText}</button>
                        )}
                    </>
                }

            </Modal.Footer>
        </Modal>
    )
}
